import { render } from "./SubmittedThesis.vue?vue&type=template&id=a7f6e2b8&scoped=true"
import script from "./SubmittedThesis.vue?vue&type=script&lang=js"
export * from "./SubmittedThesis.vue?vue&type=script&lang=js"

import "../css/SubmittedDispositions.css?vue&type=style&index=0&id=a7f6e2b8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Korisnik\\Desktop\\3. Semestar Mag\\VUI\\DiplomaInsight\\DiplomaInsight\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7f6e2b8"]])

export default __exports__